import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Source from "./Source";
import Fetcher from "../Provider/Fetcher";

/**
 * @classdesc
 * An object defining the source connection to a 3DTiles dataset from a web server.
 *
 * @extends Source
 *
 * @property {boolean} isC3DTilesSource - Used to checkout whether this source is a isC3DTilesSource. Default is
 * true. You should not change this, as it is used internally for optimisation.
 * @property {string} url - The URL of the tileset json.
 * @property {string} baseUrl - The base URL to access tiles.
 */
var C3DTilesSource = /*#__PURE__*/function (_Source) {
  _inherits(C3DTilesSource, _Source);
  var _super = _createSuper(C3DTilesSource);
  /**
   * Create a new Source for 3D Tiles data from a web server.
   *
   * @constructor
   * @extends Source
   *
   * @param {Object} source An object that can contain all properties of {@link Source}.
   * Only `url` is mandatory.
   */
  function C3DTilesSource(source) {
    var _this;
    _classCallCheck(this, C3DTilesSource);
    _this = _super.call(this, source);
    _this.isC3DTilesSource = true;
    _this.baseUrl = _this.url.slice(0, _this.url.lastIndexOf('/') + 1);
    _this.whenReady = Fetcher.json(_this.url, _this.networkOptions);
    return _this;
  }
  return _createClass(C3DTilesSource);
}(Source);
export default C3DTilesSource;